import axiosInstance from '../axiosInterceptor/axiosInstance'

const deleteInvitation = async (data) => {
  const { invitationId, orgId } = data
  const url = `v1/orgs/${orgId}/invitations/${invitationId}`
  return axiosInstance.delete(url)
}

export default deleteInvitation
